import React from "react";
import ThemeFactory from "../Shared/Theme/ThemeFactory";
import FirstAidKitLoader from "../FirstAidKit/Components/FirstAidKitLoader";

export default function FirstAidKit() {
    return <FirstAidKitLoader
        title="Apteczka"
        subtitle="Pamiętaj, wybierając się na wycieczkę zabierz ze sobą apteczkę. Czy wiesz co powinno się w niej znaleźć?"
        theme={ThemeFactory.withDirectory("first-aid-kit")}
    />
}